module.exports = __webpack_public_path__ + "static/media/aegis.f6176635.png";